import React from 'react'

interface DeleteAlertProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteAlert: React.FC<DeleteAlertProps> = ({ show, onClose, onConfirm }) => {

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!show) return null; // Return null if the modal should not be shown

    return (
        <div
            onClick={handleOverlayClick}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                // width:'30%',
                // height: 200,
                // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}>
            <div
                onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the overlay
                style={{
                    width: 300,
                    height: 200,
                    backgroundColor: '#fff',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                {/* create messege for success from server */}

                <>
                    <h2> מחיקת קובץ/תיקייה</h2>
                    <p style={{ color: 'red', fontSize: 20 }}> {"האם אתה בטוח במחיקה"} </p>
                    <button onClick={onConfirm} style={{
                        margin: '10px',
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}>
                        כן
                    </button>
                    <button onClick={onClose} style={{
                        margin: '10px',
                        padding: '10px 20px',
                        backgroundColor: '#6c757d',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}>
                        ביטול
                    </button>
                </>
            </div>
        </div>
    )
}

export default DeleteAlert